import { MapPin, QrCode } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "../api";
import type { Location } from "../types";

export function LocationsPage() {
  const [locations, setLocations] = useState<Location[]>([]);
  useEffect(() => {
    api.locations().then(setLocations);
  }, []);
  return (
    <div className="page">
      <div className="page-heading">
        <div>
          <h1>Locations</h1>
          <p>Configurable origin, transit, and Dayton destination locations.</p>
        </div>
      </div>
      <div className="location-columns">
        {(["origin", "transit", "destination"] as const).map((group) => (
          <section key={group}>
            <h2>{group}</h2>
            {locations
              .filter((location) => location.group === group)
              .map((location) => (
                <div className="location-row" key={location.id}>
                  <MapPin size={19} />
                  <span>
                    <strong>{location.name}</strong>
                    <small>{location.code}</small>
                  </span>
                  <a
                    className="icon-button"
                    href={`/api/locations/${location.id}/qr.png`}
                    target="_blank"
                    aria-label={`Open QR code for ${location.name}`}
                  >
                    <QrCode size={19} />
                  </a>
                </div>
              ))}
          </section>
        ))}
      </div>
    </div>
  );
}

